/**
 * Les paramètres du lien-capacité d'activation, relus depuis la route.
 *
 * Miroir de `ScopedLinkSigner::PARAM_*` — recopiés verbatim, à la fois pour lire le contexte et
 * pour poster l'activation. Les deux écrans les relisent eux-mêmes pour survivre à un rechargement
 * à froid : l'URL ne transporte jamais d'objet riche (`ActivationLandingScreen.js:78-94`,
 * `ActivationComposerScreen.js:127-139`).
 */
const LINK_PARAM_KEYS = ["u", "p", "sig"] as const

export type ActivationLinkParams = Record<string, string>

export type ActivationRoute = { params?: Record<string, unknown> | null } | null | undefined

export function readActivationLinkParams(route: ActivationRoute): ActivationLinkParams | null {
    const params = route?.params ?? {}
    const forwarded: ActivationLinkParams = {}
    LINK_PARAM_KEYS.forEach((key) => {
        const value = params[key]
        if (value !== undefined && value !== null) forwarded[key] = String(value)
    })

    // La signature seule rend le lien lisible ; sans elle le back refuserait de toute façon, donc
    // on épargne l'aller-retour.
    return forwarded.sig && forwarded.u ? forwarded : null
}
